module.exports = __webpack_public_path__ + "img/cutMind.b6c3898e.svg";